export const renderNative = (value) => {
  if (value) {
    return String(value)
  } else {
    return false
  }
}
